import { TContent } from "."

const managerTerms: TContent[] = [
  {
    type: "documentTitle",
    content: "POLÍTICA DE PRIVACIDADE",
  },
  {
    type: "text",
    content: `Seu direito de privacidade é muito importante para nós! Nossa política visa proporcionar ao usuário o melhor aproveitamento dos nossos serviços, com a maior segurança, protegendo as informações disponibilizadas e respeitando sua privacidade.`,
  },
  {
    type: "title",
    content: "USUÁRIOS",
  },
  {
    type: "text",
    content: `Aquele que acessa e utiliza o Sistema CONDHELP, disponibilizado no site www.condhelp.com.`,
  },
  {
    type: "title",
    content: "A CONDHELP",
  },
  {
    type: "text",
    content: `CONDHELP SOLUÇÕES LTDA é uma empresa de tecnologia, desenvolvedora do Sistema CONDHELP, inscrita no CNPJ nº 53.288.559/0001-25, sediada na Rua Vidal Vicente de Andrade, 1290, Forquilhas - São José/SC, CEP: 88107-0001.`,
  },
  {
    type: "title",
    content: "OBJETIVOS",
  },
  {
    type: "text",
    content: `Nossa Política de Privacidade, procura esclarecer nossas práticas com relação aos dados fornecidos voluntariamente pelo USUÁRIO à CONDHELP Soluções Ltda., usados, compartilhados e armazenados. Como eles nos ajudam a proporcionar o cumprimento amplo dos deveres estabelecidos com nossos clientes e usuários, que ao se cadastrar terá acesso restrito ao Sistema CONDHELP, isso indicará que você está ciente e em total e irrestrito acordo com a forma como utilizaremos as suas informações e seus dados, previstas nesta política.`,
  },
  {
    type: "title",
    content: "COLETA DE DADOS",
  },
  {
    type: "text",
    content: `Os dados fornecidos pelo USUÁRIO, será utilizado para fornecer um serviço personalizado e de qualidade. Contudo a CONDHELP Soluções Ltda., se compromete a tomar todas as medidas cabíveis, de forma a proteger a privacidade do USUÁRIO e os dados eventualmente fornecidos pelo usuário à CONDHELP Soluções Ltda., zelando pela natureza de um Sistema online e intuitivo para o segmento Condominial.`,
  },
  {
    type: "text",
    content: `Para ter acesso aos serviços CONDHELP, o USUÁRIO terá que realizar o cadastro para criar sua conta. O USUÁRIO, após esta etapa, terá acesso as modalidades do Sistema destinadas ao perfil do USUÁRIO cadastrado e declara ciente da abertura do seu cadastro, servindo tal ciência de notificação prévia, sendo dispensável qualquer
outra comunicação ao consumidor, como prevista no parágrafo segundo, do artigo 43, do Código de Proteção e Defesa do Consumidor, ou no inciso I, do artigo 1º, da Portaria nº 5/02, da Secretaria do Direito Econômico.`,
  },
  {
    type: "text",
    content: `Diversas informações poderão ser coletadas ao longo do uso do Sistema, incluindo nome completo, foto de perfil, CPF, RG, data de nascimento, CNPJ, nome da razão social, nome fantasia, insc. Estadual e Federal, CND’s, logo marcas, telefones, e-mails, preferências de contato, atas de eleição de Síndicos, endereço físico, identificadores do dispositivo, endereço IP e informações sobre localização.`,
  },
  {
    type: "text",
    content: `A CONDHELP também poderá solicitar informações de cartão de crédito, dados bancários como, banco, conta e agência. Cada uma dessas informações possui um objetivo específico e informado na ocasião, sendo opcional ao USUÁRIO informar ou não. No entanto, algumas dessas informações, quando não fornecidas, podem impedir usufruir de alguns serviços oferecidos pela CONDHELP. Dados esses que poderão ser compartilhados e armazenados em sistemas terceiros para transações financeiras, não ficando os dados bancários armazenados no sistema CONDHELP, sendo as informações compartilhadas por recursos tecnológicos de integração como API’S e WebServices.`,
  },
  {
    type: "text",
    content: `O Sistema foi desenvolvido para que o USUÁRIO tenha acesso exclusivo e intransferível, a senha criptografada é de responsabilidade exclusiva do USUÁRIO, garantindo que tenha acesso a todos os recursos disponíveis para o seu perfil de USUÁRIO no Sistema, podendo alterar, excluir, atualizar ou complementar suas próprias informações. Do mesmo modo é responsabilidade do USUÁRIO garantir a veracidade das informações e a manutenção da atualização de seus dados.`,
  },
  {
    type: "text",
    content: `O USUÁRIO aceita que seus dados, ainda que seja pessoal e permita sua identificação, poderá ser acessado e utilizado por colaboradores da CONDHELP Soluções Ltda., para:`,
  },
  {
    type: "text",
    content: `
    - Emissão de relatórios variados;<br/>
    - Desenvolvimento de novos produtos ou funcionalidades;<br/>
    - Avaliação de satisfação do serviço ou produto ofertado;<br/>
    - Auditoria sobre qualquer atividade dentro do Sistema;<br/>
    - Suporte ou solução de problemas;`,
  },
  {
    type: "text",
    content: `A CONDHELP e seus parceiros, prestadores de serviço ou produto, poderão compartilhar as informações dos USUÁRIOS entre si e usá-las de modo consistente com esta Política de Privacidade. Eles também podem juntá-las com outras informações para análise, com o intuito de fornecer e melhorar nossos produtos, serviços e benefícios.`,
  },
  {
    type: "text",
    content: `A CONDHELP considera todo e qualquer prestador de serviço ou parceiros, direta ou indiretamente fornecedor de produto ou serviço para o setor condominial, como também empresas parceiras do comércio local, seja de serviço ou produto.`,
  },
  {
    type: "text",
    content: `Essas empresas, são obrigadas a proteger suas informações e podem estar localizadas onde quer que a CONDHELP opere, Nacional ou Internacionalmente.`,
  },
  {
    type: "text",
    content: `O USUÁRIO tem o direito de ser informado sobre quais parceiros da CONDHELP têm acesso aos seus dados pessoais, bem como as finalidades desse compartilhamento. Mediante solicitação enviada ao e-mail suporte@condhelp.com, a CONDHELP fornecerá uma lista atualizada de seus parceiros e os tipos de dados compartilhados com cada um, respeitando os princípios de transparência e boa-fé.`,
  },
  {
    type: "text",
    content: `A CONDHELP só permitirá acesso aos dados pelas empresas parceiras caso as solicitações forem pertinentes aos serviços prestados pelas mesmas. Por exemplo, fazer contato com Síndicos ou Condôminos para ofertar serviço ou produto, visto que, este é escopo principal do nosso trabalho e demandam este tipo de informação.`,
  },
  {
    type: "text",
    content: `Zelamos pela segurança dos seus dados, sempre que formalizada a quebra de uma relação contratual entre CONDHELP e seus parceiros, será bloqueado imediatamente qualquer tipo acesso ao Sistema por parte da empresa parceira.`,
  },
  {
    type: "text",
    content: `Destacamos a importância que, dentro do Sistema CONDHELP, o usuário poderá ser conduzido, via link, conteúdo ou serviços, a outros portais ou plataformas que não são de propriedade da CONDHELP Soluções Ltda. e que poderão coletar suas informações e ter sua própria Política de Privacidade.`,
  },
  {
    type: "title",
    content: "USO DE DADOS",
  },
  {
    type: "text",
    content: `Os dados coletados dos usuários da CONDHELP e os registros das atividades podem ser utilizados para as seguintes finalidades:`,
  },
  {
    type: "text",
    content: `a) Identificá-los e autenticá-los adequadamente, além de processar movimentações na Conta cadastrada;`,
  },
  {
    type: "text",
    content: `b) Gerenciar funções do sistema, fornecer serviços ou produtos e cumprir obrigações decorrentes do contrato de prestação de serviços;`,
  },
  {
    type: "text",
    content: `c) Fornecer suporte ao usuário, incluindo respostas a perguntas sobre o Sistema;`,
  },
  {
    type: "text",
    content: `d) Otimizar e melhorar a experiência de uso do USUÁRIO;`,
  },
  {
    type: "text",
    content: `e) Realizar estatísticas, estudos, levantamentos e pesquisas relevantes para as atividades do comportamento dos USUÁRIOS durante o uso do Sistema;`,
  },
  {
    type: "text",
    content: `f) Promover os serviços e produtos da CONDHELP e seus parceiros;`,
  },
  {
    type: "text",
    content: `g) Informar sobre novidades, melhorias, recursos, conteúdo e outros eventos relevantes para a manutenção do relacionamento com nossos USUÁRIOS;`,
  },
  {
    type: "text",
    content: `h) Para salvaguardar os direitos e obrigações da CONDHELP relacionados ao uso do Sistema;`,
  },
  {
    type: "text",
    content: `i) Para prevenir a ocorrência de fraudes e vazamento de dados.`,
  },
  {
    type: "text",
    content: `Reforçamos que não encaminhamos seus dados para terceiros, a menos que sejamos obrigados por força de contrato, necessidade para a prestação dos serviços, solicitação do controlador, ou ordem de autoridade judicial ou outras autoridades públicas nacionais e internacionais, ou se o USUÁRIO solicitar expressamente. A CONDHELP Soluções Ltda. não irá vender, alugar ou trocar qualquer dado pessoal cadastrado dentro do Sistema.`,
  },
  {
    type: "title",
    content: "CONSENTIMENTO",
  },
  {
    type: "text",
    content: `O consentimento para as finalidades de uso dos dados será coletado de forma individual, sendo que o USUÁRIO não é obrigado a conceder. Em caso de consentimento negativo para serviços essenciais do Sistema, estes não serão disponibilizados ao USUÁRIO, podendo o acesso ser bloqueado.`,
  },
  {
    type: "text",
    content: `Haja visto que a CONDHELP, não mede esforços para proteger os dados dos USUÁRIOS, mas considerando as características dos sistemas atuais, a CONDHELP Soluções Ltda., não garante a segurança absoluta de seu Sistema, nem se responsabiliza por atos de terceiros que, eventualmente logrem êxito em coletar ou utilizar, por quaisquer meios, dados e informações disponibilizadas pelo USUÁRIO ao Sistema CONDHELP.`,
  },
  {
    type: "text",
    content: `Caso o USUÁRIO tenha dúvidas de como fazer, poderá entrar em contato com o suporte, através do e-mail suporte@condhelp.com, que teremos a maior satisfação em sanar suas dúvidas.`,
  },
  {
    type: "title",
    content: "REVISÃO E REVOGAÇÃO DE CONSENTIMENTO",
  },
  {
    type: "text",
    content: `O USUÁRIO poderá, a qualquer momento, revisar ou revogar o consentimento fornecido para o tratamento de seus dados pessoais, em conformidade com o previsto na LGPD. Essa solicitação deve ser feita através do e-mail suporte@condhelp.com. A revogação do consentimento poderá limitar o acesso a funcionalidades ou serviços que dependam do tratamento dos dados, mas não impedirá o uso de outras partes do Sistema que não sejam afetadas pela revogação.`,
  },
  {
    type: "title",
    content: "COOKIES E OUTRAS TECNOLOGIAS",
  },
  {
    type: "text",
    content: `Os sites, os serviços online, os aplicativos interativos, as mensagens por e-mail, WhatsApp e notificações via push (telefone), da CONDHELP utilizam “cookies” e outras tecnologias, como pixel tags e web beacons. Tecnologias essas que, nos ajudam a entender melhor o comportamento dos USUÁRIOS e nos informam quais partes de nossos sites as pessoas visitaram.`,
  },
  {
    type: "text",
    content: `A CONDHELP e seus parceiros também usam cookies e outras tecnologias para lembrar informações pessoais quando você utiliza
nosso Sistema, serviços online e aplicativos. Nosso objetivo, é tornar sua experiência com a CONDHELP mais agradável e personalizada.`,
  },
  {
    type: "text",
    content: `Coletamos algumas informações automaticamente e as armazenamos em arquivos de log. Essas informações incluem endereços do Protocolo da Internet (IP), tipo de navegador, idioma, localização, sites e aplicativos de encaminhamento e saída, sistema operacional, marcação de data/hora e dados de sequência de cliques (clickstream).`,
  },
  {
    type: "text",
    content: `Estas informações são utilizadas para entender e analisar os interesses, aprender sobre o comportamento do USUÁRIO no Sistema, melhorar nossos produtos e serviços e coletar informações demográficas sobre nossa base como um todo, sendo que a CONDHELP Soluções Ltda. pode usar essas informações em nossos serviços de marketing e propagandas.`,
  },
  {
    type: "text",
    content: `As pixel tags permitem enviar mensagens de e-mail em um formato que os USUÁRIOS possam ler e nos informar se o e-mail foi lido. Podemos usar essas informações para reduzir ou eliminar mensagens enviadas aos USUÁRIOS.`,
  },
  {
    type: "text",
    content: `O USUÁRIO declara estar ciente que existe a possibilidade de configurar seu navegador de preferência para ser avisado, na tela do dispositivo utilizado, sobre a aceitação dos “cookies”, e para impedir sua instalação. Informações e instruções sobre como configurar, devem ser obtidas no próprio navegador.`,
  },
  {
    type: "text",
    content: `Para utilizar nossos serviços, não é necessário que o USUÁRIO aceite o uso de “cookies” solicitados pelo nosso Sistema, sem prejuízo de que, em tal caso, será necessário que o USUÁRIO se registre toda vez que acessar uma área que requeira identificação prévia.`,
  },
  {
    type: "title",
    content: "PROTEÇÃO DE DADOS",
  },
  {
    type: "text",
    content: `A CONDHELP se preocupa e leva a segurança de suas informações pessoais muito a sério. Nossos serviços online protegem suas informações pessoais durante a transmissão por meio de criptografia. Quando seus dados pessoais são armazenados pela CONDHELP Soluções Ltda., usamos soluções em nuvem com acesso limitado e em instalações que incluem medidas físicas de segurança.`,
  },
  {
    type: "title",
    content: "ACESSO E RETENÇÃO DE INFORMAÇÕES PESSOAIS",
  },
  {
    type: "text",
    content: `Nossas soluções permitem que você acesse facilmente suas informações pessoais, bem como as mantenha atualizadas, de maneira simplificada, através de login e senha pessoal.`,
  },
  {
    type: "text",
    content: `Encerrado o período necessário para o tratamento de dados (contrato de prestação de serviços com o controlador de dados) ou a necessidade legal de manutenção dos dados, estes serão excluídos de forma automática e segura, ou serão anonimizados para fins estatísticos.`,
  },
  {
    type: "text",
    content: `O USUÁRIO pode solicitar, a qualquer momento, a exclusão antecipada de seus dados pessoais, independentemente do término do contrato de prestação de serviços. A solicitação deve ser encaminhada para o endereço de e-mail suporte@condhelp.com, e a exclusão será realizada dentro de um prazo de até 30 (trinta) dias, salvo em casos de obrigação legal de manutenção de dados ou para fins de defesa em processos judiciais.`,
  },
  {
    type: "title",
    content: "PORTABILIDADE DE DADOS",
  },
  {
    type: "text",
    content: `O USUÁRIO poderá solicitar a portabilidade de seus dados pessoais para outra plataforma, conforme previsto pela Lei Geral de Proteção de Dados (LGPD). A solicitação deve ser feita por e-mail para o endereço suporte@condhelp.com, e a CONDHELP se compromete a fornecer os dados em formato estruturado, de uso comum e leitura automática, dentro de um prazo de até 15 (quinze) dias úteis.`,
  },
  {
    type: "title",
    content: "ATUALIZAÇÕES DA POLÍTICA DE PRIVACIDADE",
  },
  {
    type: "text",
    content: `Com o avanço rápido das tecnologias na internet, à CONDHELP Soluções Ltda., reserva-se o direito de, a seu exclusivo critério, a qualquer tempo e sem aviso prévio, modificar ou alterar esta Política de Privacidade, razão pela qual se recomenda ao USUÁRIO, quando for utilizar os serviços da CONDELP Soluções Ltda., que proceda à leitura das condições vigentes a época de seu cadastro e acesso. A utilização dos serviços do nosso Sistema pelo USUÁRIO, implicará na irrestrita aceitação das condições aqui fixadas, incluindo as alterações que porventura venham ocorrer.`,
  },
  {
    type: "text",
    content: `Nossa política de privacidade é constantemente atualizada, conforme os processos e procedimentos são renovados. Atualizaremos o número e a data deste documento a cada modificação.`,
  },
  {
    type: "divider",
  },
  {
    type: "text",
    content: `Versão 1.0 de 30.11.2024`,
  },
  {
    type: "text",
    content: `Última atualização 30.11.2024`,
  },
  {
    type: "title",
    content: "LEI APLICÁVEL",
  },
  {
    type: "text",
    content: `Este regulamento será regido, interpretado e executado de acordo com as leis da República Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados ou países, sendo competente o Foro da Comarca de São José, Estado de Santa Catarina, no Brasil, para dirimir qualquer dúvida decorrente deste instrumento.`,
  },
  {
    type: "title",
    content: "SUPORTE",
  },
  {
    type: "text",
    content: `Caso o USUÁRIO tenha qualquer dúvida referente à privacidade e política de seus dados, ou ao presente termo de uso, poderá tirar suas dúvidas por e-mail, entrando em contato com o nosso canal de Suporte, suporte@condhelp.com.`,
  },
  {
    type: "text",
    content: `Quando você busca apoio através da Central de Atendimento via e-mail, os dados coletados são encaminhados para nossa central que tratará sua demanda. Os dados fornecidos não ficam arquivados para eventuais consultas sendo descartados de forma automática após atendimento.`,
  },
  {
    type: "text",
    content: `Solicitações relativas a inclusões, alterações ou exclusões de cadastro, deverão ser encaminhadas através do e-mail suporte@condhelp.com.`,
  },
]

export default managerTerms
